var map = {
	"./customer-bg.webp": 1501,
	"./customer-img.webp": 1502,
	"./dice-img.webp": 1503,
	"./games-img.webp": 1504,
	"./lc-img.webp": 1505,
	"./lottery-img.webp": 1506,
	"./mission-bg.webp": 1507,
	"./mission-img-2.webp": 1508,
	"./mission-img.webp": 1509,
	"./mission-main-bg.webp": 1510,
	"./mobile-bg.webp": 1511,
	"./p2p-img.webp": 1512,
	"./product-bg.webp": 1513,
	"./product-main-bg.webp": 1514,
	"./sb-provider.webp": 1515,
	"./sbo-provider.webp": 1516,
	"./side-bar-bg.webp": 1517,
	"./slot-img.webp": 1518,
	"./spade-img.webp": 1519,
	"./sport-img.webp": 1520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;